export const CHECKLIST_TYPES = [
	{
		id: "1",
		label: "Retirada",
		description: "PreTrip",
	},
	{
		id: "2",
		label: "Devolução",
		description: "PostTrip",
	},
];
